(() => {
  if (window.ldsCartDetailsReady) return;
  window.ldsCartDetailsReady = true;

  const rootPath = window.Shopify?.routes?.root || '/';
  let awaitingDiscountRefresh = false;
  let requestNumber = 0;

  const promoDetails = () => [...document.querySelectorAll('details.lds-cart-promo-details')];
  const hasVisibleError = details => {
    const error = details.querySelector('[data-cart-discount-error]');
    return Boolean(error?.textContent.trim()) && getComputedStyle(error).display !== 'none';
  };
  const retainEnteredState = () => {
    for (const details of promoDetails()) {
      const code = details.querySelector('[data-cart-discount-input]')?.value.trim();
      if (awaitingDiscountRefresh || code || hasVisibleError(details)) details.open = true;
    }
  };
  const syncAppliedCode = async () => {
    const request = ++requestNumber;
    retainEnteredState();
    try {
      const response = await fetch(`${rootPath}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (request !== requestNumber) return;
      const applied = Array.isArray(cart.discount_codes) && cart.discount_codes.some(entry => entry.code && entry.applicable !== false);
      if (applied) for (const details of promoDetails()) details.open = true;
      awaitingDiscountRefresh = applied;
    } catch {
      // A failed read must not hide an entered code or a visible validation error.
    }
  };

  document.addEventListener('click', event => {
    if (event.target.closest('[data-cart-discount-apply]')) {
      awaitingDiscountRefresh = true;
      event.target.closest('details.lds-cart-promo-details')?.setAttribute('open', '');
    } else if (event.target.closest('.hdt-discount-remove')) {
      awaitingDiscountRefresh = false;
    }
  });
  for (const name of ['cart:main:render', 'cart:drawer:render']) {
    document.addEventListener(name, () => requestAnimationFrame(syncAppliedCode));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAppliedCode, { once: true });
  else syncAppliedCode();
})();
